"use strict";

function eventCharacterSelection(service = {}, input = {}) {
  const raw = input.selectedCharacterIds == null ? [] : input.selectedCharacterIds;
  if (!Array.isArray(raw) || raw.length > 50 || raw.some(id => typeof id !== 'string')) {
    throw new Error('La selección de personajes no es válida.');
  }
  const ids = [...new Set(raw)];
  const catalog = Array.isArray(service.characters) ? service.characters : [];
  const choosePrimary = service.charactersMode === 'choose_primary';
  const primaryCharacterId = choosePrimary ? input.primaryCharacterId : null;
  if (choosePrimary && (typeof primaryCharacterId !== 'string' || !primaryCharacterId || !ids.includes(primaryCharacterId))) {
    throw new Error('Elige el personaje principal incluido en tu paquete.');
  }
  if (['none','included'].includes(service.charactersMode) && ids.length) {
    throw new Error('Este paquete no permite personajes adicionales. Revisa tu selección.');
  }
  const selectedCharacters = ids.map(id => {
    const character = catalog.find(row => String(row.id || row.name) === id && row.enabled !== false);
    if (!character) throw new Error('Uno de los personajes ya no está disponible. Revisa tu selección.');
    const primary = choosePrimary && id === primaryCharacterId;
    const price = primary ? 0 : Number(character.price);
    if (!primary && (character.price === '' || character.price == null || !Number.isFinite(price) || price < 0 || price > 100000)) {
      throw new Error('Revisa el recargo de los personajes adicionales.');
    }
    return {id, name: String(character.name || id).slice(0,180), price: Math.round(price * 100) / 100, ...(choosePrimary ? {role:primary?'primary':'additional'} : {})};
  });
  return {
    selectedCharacterIds: ids,
    selectedCharacters,
    charactersPrice: selectedCharacters.reduce((sum,row) => sum + Math.round(row.price * 100),0) / 100,
    ...(choosePrimary ? {primaryCharacterId, primaryCharacterName: selectedCharacters.find(row=>row.id===primaryCharacterId).name, characterSelectionVersion:'event_primary_character_v1'} : {}),
  };
}
module.exports = {eventCharacterSelection};
